import { render, staticRenderFns } from "./NewGooglePay.vue?vue&type=template&id=4e57e636&scoped=true"
import script from "./NewGooglePay.vue?vue&type=script&lang=js"
export * from "./NewGooglePay.vue?vue&type=script&lang=js"
import style0 from "./NewGooglePay.vue?vue&type=style&index=0&id=4e57e636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57e636",
  null
  
)

export default component.exports